<template>
  <div class="header d-flex flex-wrap p-2 p-md-4 px-md-5 align-content-center justify-content-between w-100">
    <div class="d-flex align-content-center mb-2 mb-md-0">
      <div class="mr-2"><img src="@/assets//image/toeic/toeic_exam/TOEIC.png" alt="" class="object-contain d-inline-block"></div>
      <div class="pt-1">
        <img src="@/assets//image/toeic/toeic_exam/Speaking.png" alt="" class="object-contain d-inline-block" v-if="$route.params.practice_type === 'speaking'">
        <img src="@/assets//image/toeic/toeic_exam/Writing.png" alt="" class="object-contain d-inline-block" v-if="$route.params.practice_type === 'writing'">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'headerSection',

    data () {
      return {

      }
    },
    props: {
    },

    components: {
    }
  }
</script>

<style lang="scss" scoped>
</style>
